import React, { useState, useEffect, useRef } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

function SliderHolidaysExplore({ section }) {
  function updateClassBasedOnScreenSize() {
  const element = document.querySelector(".holidays-explore-padding");

    if (!element) return; 

    if (window.innerWidth >= 1024) {
        element.classList.add("mb-3"); 
        
    } else {
        element.classList.remove("mb-5"); 
      
    }
  }

  window.addEventListener("load", updateClassBasedOnScreenSize);
  window.addEventListener("resize", updateClassBasedOnScreenSize);

    const [isScrolled, setIsScrolled] = useState(false);
  
  const settings = {
    dots: false,
    infinite: true,
    slidesToShow: 1, // Show 1 slide per view
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: true,
    responsive: [
        {
            breakpoint: 768, // Mobile screens
            settings: {
                slidesToShow: 1,
            },
        },
        {
            breakpoint: 1024, // Tablet screens
            settings: {
                slidesToShow: 2,
            },
        },
    ],
};

  return (
    <div class="banner-sec-tours mb-5">
    <div class="container">
      <div class="popular-state pb-0 pt-0 holidays-explore-padding">
        <div class="title text-center">
          <h3 class="pb-0">{section?.title_highlight ? <span>{section.title_highlight} </span> : <span>Explore </span>} {section?.title || 'The Hidden Gems'}</h3>
          <p class="max-width-100">{section?.subtitle || 'Tap into the untapped tourist spots for amazing vacations.'}</p>
        </div>
      </div>
      <div
        className={`tours-banner-sec-home slider slides-wrapper ${
          isScrolled ? "slide" : ""
        }`}
      >
     
      <Slider {...settings}>
        {(section?.Items?.length ? section.Items : [
          { title: 'Slide 1', image_url: 'assets/img/home/tours/1.png' },
          { title: 'Slide 2', image_url: 'assets/img/home/tours/2.png' },
          { title: 'Slide 3', image_url: 'assets/img/home/tours/3.png' },
          { title: 'Slide 4', image_url: 'assets/img/home/tours/4.png' },
        ]).map((item, index) => (
          <div className="slide" key={index}>
            <img src={item.image_url} className="br-12" alt={item.title} />
          </div>
        ))}
      </Slider>
      </div>
    </div>
  </div>
  
  );
}

export default SliderHolidaysExplore;
